export default __webpack_public_path__ + "static/media/889.fa8c1d97.png";